import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LoginComponent } from './login/login.component';
import { ReactiveFormsModule } from '@angular/forms';
import { AuthRoutes } from './auth.routing';
import { CoreModule } from 'src/app/core/core.module';
import { CreatePasswordComponent } from './create-password/create-password.component';
import { MatIconModule } from '@angular/material/icon';
import { ShareModule } from '../share/share.module';
import { ForgotPasswordComponent } from './forgot-password/forgot-password.component';
import { ResetPasswordComponent } from './reset-password/reset-password.component';



@NgModule({
  declarations: [
    LoginComponent,
    CreatePasswordComponent,
    ForgotPasswordComponent,
    ResetPasswordComponent
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    AuthRoutes,
    CoreModule,
    MatIconModule,
    ShareModule
  ]
})
export class AuthModule { }
